import React, { useState } from "react";
import DashboardTV from "../features/DualScreen/DashboardTV";
import { getStatsFolderHelp } from "services/folderHelp";
import { sendDashboardToDualScreen } from "services/dualScreen";
import { useSafePolling } from "hooks/useSafePolling";
import { useDispatch } from "react-redux";

const DashboardHelpNurse = () => {
	const [stats, setStats] = useState(null);
	const dispatch = useDispatch();
	useSafePolling(
		() =>
			dispatch(getStatsFolderHelp()).then((res) => {
				setStats(res.payload.data);
				dispatch(sendDashboardToDualScreen(res.payload.data));
			}),
		{
			delay: 12000,
			timeoutThreshold: 12000,
			enabled: true,
		}
	);

	return <div>{stats && <DashboardTV stats={stats} />}</div>;
};

export default DashboardHelpNurse;
